






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import { uploader } from "./uploader.js";
import UploadBlock from "../UploadBlock.vue";
import XLSX from "xlsx";

const Root = namespace("root");

@Component({
  components: { UploadBlock }
})
export default class ImportTemplate extends Vue {
  @Prop({ default: "" }) templateUrl: String;
  @Prop({ default: "small" }) size: String;
  @Prop({ default: false }) remote: Boolean;

  @Root.Action createImportFile;
  @Root.Action downTemplate;

  category = "";
  dataList = [];
  hasAlarted = false;
  private timeEr = null;
  private loading = false;

  private file = null;
  private fileName = "";
  private id = `uploaderblock_${Math.random()}`;
  private dataAfterParse = null;

  destroyed() {
    window.clearInterval(this.timeEr);
  }

  beforeRouteLeave(to, from, next) {
    if (to.params.name !== from.params.name) {
      window.clearInterval(this.timeEr);
      next();
    }
  }
  async onTempDownloadClick(template) {
    let url = "";
    if (typeof template === "string") {
      url = template;
    } else {
      url = await this.downTemplate(template);
    }

    if (!url) return;

    this.createDownA(url);
  }

  createDownA(url) {
    let eleLink = document.createElement("a");
    eleLink.download = url;
    eleLink.style.display = "none";
    eleLink.href = url;
    document.body.appendChild(eleLink);
    eleLink.click();
    document.body.removeChild(eleLink);
  }

  handleSelectFile() {
    // 调用 uploader.js 中选择文件的 method
    uploader.selectFile(file => {
      this.fileName = file["name"];
      if (!this.remote) {
        this.file = file;
      }
    });
  }

  // remove result
  handleRemoveFile() {
    this.$emit("remove");
    this.clearFile();
  }
  toggleRemove() {
    this.handleRemoveFile();
  }

  async beforeUpload({ name }) {
    const { locale, org: orgCode = "default" } = localStorage;
    const fetchData = {
      category: this.category,
      name,
      // orgCode,
      metadata: [
        {
          name: "locale",
          value: locale || "en"
        },
        {
          name: "relationOrgCode",
          value: "default"
        }
      ]
    };

    return await this.createImportFile(fetchData);
  }
  async successCallback() {
    // 第一次上传文件 会弹出提示文本 只提示一次
    if (!this.hasAlarted) {
      this.$alert((this as any).$t("Root.Import.importing"), {
        confirmButtonText: (this as any).$t("Root.Import.got_it")
      });
    } else {
      this.hasAlarted = true;
    }

    // hiddle select file path
    this.fileName = "";
    this.$emit("success");
  }
  onImportClick() {
    if (!this.remote) {
      this.onImportFile();
    } else {
      this.onUploadClick();
    }
  }
  async onImportFile() {
    if (this.loading || !this.file) return;
    if (this.dataAfterParse) {
      this.clearFile();
      return;
    }
    try {
      this.loading = true;
      let reader = new FileReader();
      reader.onload = async e => {
        let data = e.target.result;
        let workbook = XLSX.read(data, { type: "binary" });
        let sheetData = {};
        // 目前只会读取sheet1的数据
        let sheet1 = workbook.SheetNames[0];

        if (sheet1) {
          sheetData = workbook.Sheets[sheet1];
        }
        const onParseData = async raw => {
          let json = [];
          if (raw) {
            try {
              json = XLSX.utils.sheet_to_json(raw);
            } catch (_) {
              console.error(_);
            }
          }
          return json;
        };
        // start parse
        this.dataAfterParse = await onParseData(sheetData);
        const sleep = async time => {
          return new Promise(resolve => {
            setTimeout(() => {
              resolve("resolve");
            }, time * 1000);
          });
        };
        await sleep(2);
        this.loading = false;

        // 兼容dataAfterParse 为 async function 的情况
        if (typeof this.dataAfterParse === "function") {
          this.dataAfterParse = await this.dataAfterParse();
        }
        this.$emit("change", this.dataAfterParse);
      };
      const { file, id } = this;
      reader.readAsBinaryString(file);
      // clear
      // let el = document.getElementById(id);
      // el && (el.value = "");
    } catch (err) {
      this.loading = false;
      console.error(err);
    }
  }
  onUploadClick() {
    uploader.setOption({
      beforeUploadCallback: this.beforeUpload,
      successCallback: this.successCallback
    });

    uploader.upload();
  }
  beforeDestroy() {
    this.clearFile();
  }
  clearFile() {
    this.file = null;
    this.fileName = "";
    this.dataAfterParse = null;
    uploader.removeFile();
  }
}
